import React from 'react';
import { CheckoutPage } from './components/CheckoutPage';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a0a0a]" data-id="element-0">
      <CheckoutPage data-id="element-1" />
    </div>;
}